import { FormFieldType } from '../typings';
import type { FormFieldWarning, SingleFormField } from '../typings';

/**
 * Both sides are zero-padded `yyyy-MM-dd`, so lexicographic order is calendar
 * order. Comparing strings keeps the check free of timezone conversion — see
 * `parseDateFromString` for the same reasoning applied to parsing.
 */
const isDateWithinWarning = (value: string, warning: FormFieldWarning): boolean =>
  warning.maxValue !== undefined && value <= warning.maxValue;

/** The first warning whose condition the field's current value meets. */
export const findActiveFieldWarning = (
  field: SingleFormField,
  value: unknown,
): FormFieldWarning | undefined => {
  if (!field.warnings?.length) return undefined;
  if (typeof value !== 'string' || value === '') return undefined;

  // Only dates carry warnings today; the field's own type picks the comparison.
  if (field.type !== FormFieldType.Date) return undefined;

  return field.warnings.find(warning => isDateWithinWarning(value, warning));
};
